export const AGENT_CHAT_MAX_MESSAGE_LENGTH = 8_000;
export const AGENT_CHAT_MIN_SEND_INTERVAL_MS = 1_000;
export const AGENT_CHAT_MAX_ATTACHMENTS = 5;
export const AGENT_CHAT_MAX_ATTACHMENT_BYTES = 4 * 1024 * 1024;

/** Persisted drawer width key (px string, e.g. `"420px"`). */
export const AGENT_CHAT_DRAWER_WIDTH_STORAGE_KEY =
	"illumi-agent-chat-drawer-width";
export const AGENT_CHAT_DRAWER_DEFAULT_WIDTH_PX = 420;
export const AGENT_CHAT_DRAWER_MIN_WIDTH_PX = 320;
export const AGENT_CHAT_DRAWER_MAX_WIDTH_PX = 720;
/** Cap max width at this fraction of the viewport. */
export const AGENT_CHAT_DRAWER_MAX_VIEWPORT_RATIO = 0.5;
/**
 * Minimum board (canvas) width reserved via CSS max-width on the push
 * drawer (`--illumi-agent-chat-min-board` in index.css).
 */
export const AGENT_CHAT_MIN_BOARD_WIDTH_PX = 360;
/** Keep in sync with SideBar localStorage in sidebar-components.tsx. */
export const SIDEBAR_WIDTH_STORAGE_KEY = "illumi-sidebar-width";
export const SIDEBAR_DEFAULT_WIDTH_PX = 300;
export const AGENT_CHAT_LLM_MODEL_STORAGE_KEY = "illumi-agent-chat-llm-model";
export const AGENT_CHAT_TEXT_ATTACHMENT_EXTENSIONS = [
	".txt",
	".md",
	".csv",
	".json",
] as const;
export const AGENT_CHAT_FILE_INPUT_ACCEPT = [
	"image/*",
	".txt",
	".md",
	".csv",
	".json",
	"text/plain",
	"text/markdown",
	"text/csv",
	"application/json",
].join(",");
